import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import styled from "styled-components";
import AppHeader from "./components/AppHeader.js";
import SlayerApp from "./components/SlayerApp.js";
import InfoPage from "./components/InfoPage.js";
import PrivacyPage from "./components/PrivacyPage.js";
import TermsPage from "./components/TermsPage.js";
import AppFooter from "./components/AppFooter.js";

const App = () => {
  return (
    <Router>
      <AppContainer>
        <AppHeader />
        <Routes>
          <Route path="/" element={<SlayerApp />} />
          <Route path="/info" element={<InfoPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
        </Routes>
        <AppFooter />
      </AppContainer>
    </Router>
  );
};

export default App;

const AppContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 99vh;
  margin: 10px 50px;
  color: #ffff00;
  font-family: "Chakra Petch", sans-serif;
`;
